import logoImg from 'assets/images/popup-logo.svg';

import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';
import Image from 'quarks/Image';
import Link from 'quarks/Link';
import Text from 'quarks/Text';

import type { ContentfulComponentSingleInstance } from 'graphqlTypes';
import type { FC } from 'react';

type MerchantPortalProps = ContentfulComponentSingleInstance;

const MerchantPortal: FC<MerchantPortalProps> = () => (
  <Flex
    flexDirection="column"
    width="100%"
    maxWidth="100%"
    marginX="auto"
    gap="16px"
    boxShadow="xxl"
    paddingX={24}
    paddingY={32}
    marginY={48}
    borderRadius="12px"
    md={{ maxWidth: '650px', paddingX: 48, paddingY: 96, marginY: 96 }}
  >
    <Image image={{ file: { url: logoImg } }} alt="Logo" width="200px" marginX="auto" />
    <Heading as="h2" textStyle="h4" textColor="navy-700" textAlign="left" marginTop={16}>
      Important Update
    </Heading>
    <Text textStyle="textSm" textColor="gray-700">
      {
        "The Merchant Portal's URL has switched to a FieldRoutes URL. Please bookmark, login with existing credentials, and use it going forward."
      }
    </Text>
    <Link href="https://merchantportal.fieldroutes.com" fontSize="textSm" lineHeight="textSm" textColor="green-600">
      https://merchantportal.fieldroutes.com
    </Link>
  </Flex>
);

export default MerchantPortal;
